export const SECTION_TITLE = 'TÁC PHẨM "SỬA ĐỔI LỐI LÀM VIỆC"'

export const SLIDERS = [
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685287227/2022-2023/HCM/sua-doi-loi-lam-viec_t9lq0q.webp',
        title: '',
        content: ''
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685287227/2022-2023/HCM/sua-doi-loi-lam-viec_t9lq0q.webp',
        title: '',
        content: ''
    },
]

export const ITEMS = [ 
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685195178/2022-2023/HCM/suadoiloilamviec-01_cryznh.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685195178/2022-2023/HCM/suadoiloilamviec-02_cxy3r4.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685195179/2022-2023/HCM/suadoiloilamviec-03_i54hl6.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685195179/2022-2023/HCM/suadoiloilamviec-04_owchde.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685195179/2022-2023/HCM/suadoiloilamviec-05_yvm02e.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685195179/2022-2023/HCM/suadoiloilamviec-06_za5av3.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685195180/2022-2023/HCM/suadoiloilamviec-07_vqgpgn.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685195180/2022-2023/HCM/suadoiloilamviec-08_tnq6bx.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685195180/2022-2023/HCM/suadoiloilamviec-09_fdgsts.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685195181/2022-2023/HCM/suadoiloilamviecC2a_ecj1nd.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685195181/2022-2023/HCM/suadoiloilamviecC2b_n9rj8n.webp',
        title: '',
    },
]